import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { getFromLocal, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  public form: FormGroup;
  hideNewPassword = true;
  hideConfirmPassword = true;

  requirements = [
    { label: 'Mínimo 8 caracteres de longitud', met: false, visible: true },
    { label: 'Al menos 1 número', met: false, visible: true },
    { label: 'Al menos 2 letras', met: false, visible: true },
    { label: 'Al menos 1 carácter especial (excepto +)', met: false, visible: true },
    { label: 'Las contraseñas coinciden', met: false, visible: false },
  ];

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private helpers: HelpersService,
    private router: Router
  ) {
    this.form = this.fb.group({
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {
    if (!getFromLocal('cp_token')) {
      this.router.navigate(['/auth/login']);
    }
  }

  private passwordsMatch(control: AbstractControl): ValidationErrors | null {
    const newPass = control.get('newPassword')?.value;
    const confirmPass = control.get('confirmPassword')?.value;
    return newPass === confirmPass ? null : { mismatch: true };
  }

  onPasswordChange(value: string): void {
    this.requirements[0].met = value.length >= 8;
    this.requirements[1].met = /\d/.test(value);
    this.requirements[2].met = (value.match(/[a-zA-Z]/g) || []).length >= 2;
    this.requirements[3].met = /[^a-zA-Z0-9+]/.test(value);
    const confirmValue = this.form.get('confirmPassword')?.value;
    if (confirmValue?.length > 0) {
      this.requirements[4].met = value === confirmValue;
    }
  }

  onConfirmPasswordChange(value: string): void {
    this.requirements[4].visible = value.length > 0;
    this.requirements[4].met = value.length > 0 && value === this.form.get('newPassword')?.value;
  }

  get allRequirementsMet(): boolean {
    return this.requirements.every(r => !r.visible || r.met);
  }

  async submit(event: Event): Promise<void> {
    event.preventDefault();
    if (!this.allRequirementsMet) {
      this.helpers.notifications.warningMessage('La contraseña no cumple con los requisitos mínimos');
      return;
    }
    if (this.form.hasError('mismatch')) {
      this.helpers.notifications.warningMessage('Las contraseñas no coinciden');
      return;
    }
    if (!this.form.valid) {
      this.helpers.notifications.warningMessage('Por favor complete todos los campos');
      return;
    }
    showSpinner();
    const response = await this.authService.changePassword(this.form.value.newPassword);
    if (response.success) {
      this.helpers.notifications.successMessage('Contraseña cambiada exitosamente');
      this.authService.clearChangePasswordData();
      this.router.navigate(['/auth/login']);
    } else {
      this.helpers.notifications.errorMessage(response.message);
    }
    hideSpinner();
  }

  goBack(): void {
    this.authService.clearChangePasswordData();
    this.router.navigate(['/auth/login']);
  }
}
